<template>
  <g>
    <path
      d="M2.783 21L21.533 3"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.964,19.051A9.985,9.985,0,0,0,12,19.5c4.1.069,8.258-2.813,10.824-5.637a1.663,1.663,0,0,0,0-2.226,20.568,20.568,0,0,0-3.074-2.757"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.413,6.282A9.549,9.549,0,0,0,12,6C7.969,5.933,3.8,8.752,1.179,11.635a1.663,1.663,0,0,0,0,2.226,20.8,20.8,0,0,0,2.6,2.4"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.25,12.75A3.749,3.749,0,0,1,12,9"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.75,12.749h0A3.75,3.75,0,0,1,12,16.5"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconNotVisible",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>
